import clone from 'clone';
import { findIndex } from 'underscore';
import moment from 'moment';
import Fuse from 'fuse.js';

class DoFilterOnData {

  constructor(options) {
    this.metakey = options.metakey;
    this.availableData = clone(options.availableData);
    this.urlData = options.urlData;
    this.filterTermData = options.filterTermData;
    this.props = options.props;
    this.isUrlTermKeyInAvailableData = this.isUrlTermKeyInAvailableData.bind(this);
    this.filterDataLinear = this.filterDataLinear.bind(this);
    this.filterDataForTree = this.filterDataForTree.bind(this);
    this.buildTree = this.buildTree.bind(this);
    this.filterMetaDataForRange = this.filterMetaDataForRange.bind(this);
    this.filterDataForTextBox = this.filterDataForTextBox.bind(this);
    this.filterMetaDataForDate = this.filterMetaDataForDate.bind(this);
    this.filterDataForAllMeta = this.filterDataForAllMeta.bind(this);
    this.filterDataPrequery = this.filterDataPrequery.bind(this);
    this.filterMetaDataForRnB = this.filterMetaDataForRnB.bind(this);
  }
  filterDataPrequery() {
    const data = clone(this.availableData);
    let selectedMeta = [];
    let selectedTaxonomy = [];
    if (this.props.settingsData.hasOwnProperty('prequery')) {
      if (this.props.settingsData.prequery.hasOwnProperty('meta')) {
        selectedMeta = clone(this.props.settingsData['prequery']['meta']);
      }
      if (this.props.settingsData.prequery.hasOwnProperty('taxonomy')) {
        selectedTaxonomy = clone(this.props.settingsData['prequery']['taxonomy']);
      }
    }
    let filteredData = [];
    if (selectedMeta.length === 0 && selectedTaxonomy.length === 0) {
      filteredData = clone(data);
    } else {
      data.map((item) => {
        // console.log(item);
        let checkTaxonomy = true;
        for (let index = 0; index < selectedMeta.length; index++) {
          if (item.meta.hasOwnProperty(selectedMeta[index])) {
            filteredData.push(item);
            checkTaxonomy = false;
            break;
          }
        }
        if (checkTaxonomy === true) {
          for (let index = 0; index < selectedTaxonomy.length; index++) {
            if (item.terms.hasOwnProperty(selectedTaxonomy[index])) {
              if (item.terms[selectedTaxonomy[index]].length !== 0) {
                filteredData.push(item);
                break;
              }
            }
          }
        }
      });
    }
    this.availableData = clone(filteredData);
  }
  filterDataForTextBox(searchValue) {
    const data = clone(this.availableData);
    let filteredData = [];
    const searchkeys = [];
    if (data.length > 0) {
      for (const key in data[0]) {
        if (data[0].hasOwnProperty(key)) {
          if (typeof data[0][key] === 'string') {
            searchkeys.push(key);
          }
          if (_.isObject(data[0][key])) {
            for (const innerkey in data[0][key]) {
              if (data[0][key].hasOwnProperty(innerkey)) {
                searchkeys.push(`${key}.${innerkey}`);
              }
            }
          }
        }
      }
    }
    const options = {
      shouldSort: true,
      threshold: 0.4,
      location: 0,
      distance: 100,
      maxPatternLength: searchkeys.length,
      keys: searchkeys,
    };
    const fuse = new Fuse(data, options); // "list" is the item array
    filteredData = fuse.search(searchValue);
    this.availableData = clone(filteredData);
  }
  isUrlTermKeyInAvailableData(item, urlTermKey, urlTermValues) {
    let termOption = urlTermValues;
    if (!(_.isArray(urlTermValues))) {
      const singleValue = urlTermValues;
      termOption = [];
      termOption.push(singleValue);
    }
    const index = _.intersection(item.terms[urlTermKey], termOption);
    if (index.length !== 0) this.filterTermData.push(item);
  }

  filterDataLinear(resultTermData, urlTermKey, urlTermValues) {
    resultTermData.map((item) => {
      if (item.terms[urlTermKey] !== undefined) {
        this.isUrlTermKeyInAvailableData(item, urlTermKey, urlTermValues);
      }
    });
    this.availableData = clone(this.filterTermData);
    this.filterTermData = [];
  }
  filterDataForAllMeta(searchValues, key) {
    let urlTermValues = [];
    let filteredData = [];
    if (!(_.isArray(searchValues))) {
      urlTermValues.push(searchValues.toString());
    } else {
      urlTermValues = clone(searchValues);
    }
    const allData = clone(this.availableData);
    allData.map((item) => {
      if (item.meta.hasOwnProperty(key)) {
        const index = _.indexOf(urlTermValues, item.meta[key]);
        if (index !== -1) {
          filteredData.push(item);
        }
      }
    });
    this.availableData = clone(filteredData);
  }
  filterDataForTree(resultTermData, urlTermValues) {
    const tempfilteredOr = [];
    resultTermData.map((item) => {
      if ((_.intersection(item.terms[this.selectedTermKey], urlTermValues)).length === urlTermValues.length) {
        tempfilteredOr.push(item);
      }
    });
    this.filteredOr = _.union(this.filteredOr, tempfilteredOr);
  }

  buildTree(item, urlTree) {
    const index = findIndex(this.selectedTerms, { slug: item.slug });
    if (index !== -1) {
      urlTree.push(item.slug);
      if (item.children.length === 0) {
        this.filterDataForTree(this.availableData, urlTree);
        return;
      }
      for (let i = 0; i < item.children.length; i++) {
        this.buildTree(item.children[i], clone(urlTree));
      }
      const isSingle = findIndex(this.selectedTerms, { parent: item.term_id });
      if (isSingle === -1) {
        this.filterDataForTree(this.availableData, urlTree);
      }
    }
    if (index === -1) {
      return;
    }
  }
  filterMetaDataForRange(rangeInput, metaKey) {
    const filteredData = [];
    this.availableData.map((item) => {
      if (item.meta.hasOwnProperty(metaKey)) {
        if (parseInt(item.meta[metaKey], 10) >= parseInt(rangeInput.min, 10) && parseInt(item.meta[metaKey], 10) <= parseInt(rangeInput.max, 10)) {
          filteredData.push(item);
        }
      }
    });
    this.availableData = clone(filteredData);
  }
  filterMetaDataForDate(daterange, metaKey) {
    const filteredData = [];
    const allData = clone(this.availableData);
    allData.map((item) => {
      if (metaKey === 'post_date') {
        if (item.hasOwnProperty(metaKey)) {
          const start = moment(daterange.start).format('YYYY-MM-DD');
          const end = moment(daterange.end).format('YYYY-MM-DD');
          const bookedDate = moment(item[metaKey]).format('YYYY-MM-DD');
          if ((moment(start).isBefore(bookedDate) && moment(end).isAfter(bookedDate)) || moment(start).isSame(bookedDate) || moment(end).isSame(bookedDate)) {
            filteredData.push(item);
          }
        }
      } else {
        if (item.meta.hasOwnProperty(metaKey)) {
          const start = moment(daterange.start).format('YYYY-MM-DD');
          const end = moment(daterange.end).format('YYYY-MM-DD');
          const bookedDate = moment(item.meta[metaKey], 'DD/MM/YYYY').format('YYYY-MM-DD');
          if ((moment(start).isBefore(bookedDate) && moment(end).isAfter(bookedDate)) || moment(start).isSame(bookedDate) || moment(end).isSame(bookedDate)) {
            filteredData.push(item);
          }
        }
      }
    });
    this.availableData = clone(filteredData);
  }
  filterMetaDataForRnB(daterange, metaKey) {
    const filteredData = [];
    const allData = clone(this.availableData);
    allData.map((item) => {
      if (item.meta.hasOwnProperty(metaKey)) {
        const start = moment(daterange.start).format('MM/DD/YYYY');
        const end = moment(daterange.end).format('MM/DD/YYYY');
        const bookedDate = clone(item.meta[metaKey]);
        let flag = true;
        for (let index = 0; index < bookedDate.length; index++) {
          if ((moment(start).isBefore(bookedDate[index]) && moment(end).isAfter(bookedDate[index])) || moment(start).isSame(bookedDate[index]) || moment(end).isSame(bookedDate[index])) {
            flag = false;
            break;
          }
        }
        if (flag === true) {
          filteredData.push(item);
        }
      }
    });
    this.availableData = clone(filteredData);
  }
  filterOperation() {
    for (const key in this.urlData) {
      const isTaxonomy = _.indexOf(this.props.helperData.taxonomies, key.toString());
      if (this.urlData.hasOwnProperty(key) && isTaxonomy !== -1) {
        let searchType = [];
        if (!(_.isArray(this.urlData[key]))) {
          searchType.push(this.urlData[key]);
        } else {
          searchType = clone(this.urlData[key]);
        }
        this.selectedTerms = [];
        searchType.map((item) => {
          const index = findIndex(this.props.helperData.terms[key].linear, { slug: item.toString() });
          if (index !== -1) this.selectedTerms.push(this.props.helperData.terms[key].linear[index]);
        });
        let numberOfParent = 0;
        this.selectedTerms = _.sortBy(this.selectedTerms, 'parent');
        this.selectedTerms.map((item) => {
          if (item.parent === 0) {
            numberOfParent++;
          }
        });
        this.comboIndex = null;
        const indexSearchBlock = findIndex(this.props.allLayout, { type: 'search' });
        if (indexSearchBlock !== -1) {
          const searchAttr = clone(this.props.allLayout[indexSearchBlock].searchAttr);
          this.comboIndex = findIndex(searchAttr, { selectedTaxonomy: key.toString(), viewType: 'combobox' });
        }
        if ((numberOfParent === this.selectedTerms.length) || (this.comboIndex === -1)) {
          this.filterDataLinear(this.availableData, key.toString(), this.urlData[key]);
        } else {
          this.filteredOr = [];
          this.selectedTermKey = key;
          this.selectedTerms.map((item) => {
            if (item.parent === 0) {
              const index = findIndex(this.props.helperData.terms[key].complex, { term_id: item.key });
              this.buildTree(this.props.helperData.terms[key].complex[index], []);
            }
          });
          this.availableData = (_.intersection(this.availableData, this.filteredOr));
        }
      } else {
        let fieldType = null;
        const rangeInput = {};
        const dateRangeData = {};
        let searchValue = null;
        const isRange = key.indexOf('[min]');
        const isRangeMax = key.indexOf('[max]');
        if (isRangeMax !== -1) {
          fieldType = 'rangeInputMax';
        }
        let metaKey = null;
        if (isRange !== -1) {
          metaKey = key.split('[min]').length ? key.split('[min]')[0] : null;
          rangeInput.min = this.urlData[key];
          rangeInput.max = this.urlData[metaKey + '[max]'];
          fieldType = 'rangeInput';
        }
        if (key.toString() === 'search_item') {
          fieldType = 'textbox';
          searchValue = this.urlData[key];
        }
        const isDate = key.indexOf('[start]');
        const isDateEnd = key.indexOf('[end]');
        if (isDate !== -1) {
          const tempKey = key.split('[start]').length ? key.split('[start]')[0] : null;
          fieldType = 'daterange';
          dateRangeData.start = this.urlData[tempKey + '[start]'];
          dateRangeData.end = this.urlData[tempKey + '[end]'];
          searchValue = this.urlData[key];
          metaKey = tempKey;
          const { allLayout } = this.props;
          for (let i = 0; i < allLayout.length; i++) {
            if (allLayout[i].type === 'search') {
              const searchAttr = allLayout[i].searchAttr;
              const isRnb = findIndex(searchAttr, { viewType: 'rnb-daterange' });
              if (isRnb !== -1) {
                fieldType = 'rnb-daterange';
              }
            }
          }
        }
        if (isDateEnd !== -1) {
          fieldType = 'daterangeEnd';
        }
        if (key.toString() === 'pagenumber') {
          fieldType = 'pagination';
        }
        if (key.toString() === 'view') {
          fieldType = 'view';
        }
        if (key.toString() === 'location') {
          fieldType = 'mapSearch';
        }
        switch (fieldType) {
          case 'rangeInput':
            this.filterMetaDataForRange(rangeInput, metaKey);
            break;
          case 'rangeInputMax':
            break;
          case 'daterangeEnd':
            break;
          case 'pagination':
            break;
          case 'view':
            break;
          case 'textbox':
            this.filterDataForTextBox(searchValue);
            break;
          case 'daterange':
            this.filterMetaDataForDate(dateRangeData, metaKey);
            break;
          case 'rnb-daterange':
            this.filterMetaDataForRnB(dateRangeData, metaKey);
            break;
          case 'mapSearch':
            break;
          default:
            this.filterDataForAllMeta(this.urlData[key], key);
            break;
        }
      }
    }
    ReactiveFanoutData.availableDataLength = this.availableData.length;
    return this.availableData;
  }
}

export default DoFilterOnData;



/** WEBPACK FOOTER **
 ** ./assets/src/frontend/preview/filterOperation.js
 **/